






















import InfoUser from '@/components/InfoUser.vue'
import PaymentDetail from '@/components/PaymentDetail.vue'
import Card from '@/components/Card.vue'
import PaymentBase from './PaymentBase'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { Vue, Component, Prop, Watch, Mixins } from "vue-property-decorator";
import ModalBase from '@/components/ModalBase.vue';

Vue.component(VueQrcode.name, VueQrcode);

@Component({
  components: {
    Card,
    ModalBase
  }
})
export default class TinabaPay extends PaymentBase {
  @Prop() readonly payment!: Checkout
}
